import React from "react";
import { Row, Col, Card, Table, Divider, Typography } from "antd";
import { useStateValue } from "../stateProvider/stateProvider";
import "./infoDamage.css";

const { Title, Text } = Typography;

const columnsNL = [
  {
    title: "",
    dataIndex: "company",
    key: "company",
    render: (text) =>
      text === "B2Bike" ? (
        <span>
          {text} <span style={{ color: "red", fontWeight: "bold" }}>*</span>
        </span>
      ) : (
        text
      ),
  },
  {
    title: "@ (cc:schade@b2bike.be)",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Diefstal: sleutels",
    dataIndex: "keys",
    key: "keys",
  },
  {
    title: "Vrijstelling in eigen schade",
    dataIndex: "franchise",
    key: "franchise",
  },
  {
    title: "Diefstal/TV > nieuwe fiets?",
    dataIndex: "replacement",
    key: "replacement",
  },
];

const columnsFR = [
  {
    title: "",
    dataIndex: "company",
    key: "company",
    render: (text) =>
      text === "B2Bike" ? (
        <span>
          {text} <span style={{ color: "red", fontWeight: "bold" }}>*</span>
        </span>
      ) : (
        text
      ),
  },
  {
    title: "@ (cc:schade@b2bike.be)",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Vol: clés",
    dataIndex: "keys",
    key: "keys",
  },
  {
    title: "Franchise: en tort",
    dataIndex: "franchise",
    key: "franchise",
  },
  {
    title: "Vol / perte total > nouveau vélo?",
    dataIndex: "replacement",
    key: "replacement",
  },
];

const dataSourceFR = [
  {
    key: "1",
    company: "B2Bike",
    email: "info@equinoxinsurance.be",
    keys: "Photo",
    franchise: "€ 25 (à payer dans le magasin)",
    replacement: "Dans le contrat existant",
  },
  {
    key: "2",
    company: "J&T",
    email: "info@equinoxinsurance.be",
    keys: "Photo",
    franchise: "€ 25 (à payer dans le magasin)",
    replacement: "Dans le contrat existant",
  },
  {
    key: "3",
    company: "Alphabet",
    email: "insurancedamage@alphabet.be",
    keys: "Mail",
    franchise: "35 / 150",
    replacement: "Fin du contrat",
  },
  {
    key: "4",
    company: "Ayvens",
    email: "damage.be@ayvens.com",
    keys: "Mail",
    franchise: "€ 75",
    replacement: "Contrat existant",
  },
  {
    key: "5",
    company: "Arval",
    email: "insurance.be@arval.be",
    keys: "Mail",
    franchise: "Indiqué sur le contrat de leasing",
    replacement: "Fin du contrat",
  },
  {
    key: "6",
    company: "Dieteren",
    email: "dieteren@pv.be",
    keys: "Mail",
    franchise: "Dégât: € 150, Vol: € 500",
    replacement: "Fin du contrat",
  },
];

const dataSourceNL = [
  {
    key: "1",
    company: "B2Bike",
    email: "info@equinoxinsurance.be",
    keys: "Foto",
    franchise: "€ 25 (direct afrekenen met bestuurder)",
    replacement: "In bestaand contract",
  },
  {
    key: "2",
    company: "J&T",
    email: "info@equinoxinsurance.be",
    keys: "Foto",
    franchise: "€ 25 (direct afrekenen met bestuurder)",
    replacement: "In bestaand contract + facturatie J&T <> B2Bike",
  },
  {
    key: "3",
    company: "Alphabet",
    email: "insurancedamage@alphabet.be",
    keys: "Mail",
    franchise: "35 / 150",
    replacement: "Contract stopt",
  },
  {
    key: "4",
    company: "Ayvens",
    email: "damage.be@ayvens.com",
    keys: "Mail",
    franchise: "€ 75",
    replacement: "Contract loopt door",
  },
  {
    key: "5",
    company: "Arval",
    email: "insurance.be@arval.be",
    keys: "Mail",
    franchise: "staat op lease-offerte",
    replacement: "Contract stopt",
  },
  {
    key: "6",
    company: "Dieteren",
    email: "dieteren@pv.be",
    keys: "Mail",
    franchise: "Eigen schade: €150, diefstal: €500",
    replacement: "Contract stopt",
  },
];

const theadStyle = {
  backgroundColor: "#7CBC1F",
  color: "white",
  height: "64px",
};

const InfoDamage = () => {
  const [{ userDetails }] = useStateValue();

  if (!userDetails) return null;

  const reportFormTheftDamageNL = (
    <li>
      <a
        href="https://www.b2bikeclaims.be/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Aangifte formulier Schade/Diefstal (safebike/equinox)
      </a>
    </li>
  );

  const reportFormTheftDamageMaternéNL = (
    <li>
      <a
        href="https://form.jotform.com/213005933903348"
        target="_blank"
        rel="noopener noreferrer"
      >
        Aangifte formulier Schade/Diefstal (Materné)
      </a>
    </li>
  );

  const reportFormTheftDamageFR = (
    <li>
      <a
        href="https://www.b2bikeclaims.be/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Flux en cas de sinistre Safebike (safebike/equinox)
      </a>
    </li>
  );

  const reportFormTheftDamageMaternéFR = (
    <li>
      <a
        href="https://form.jotform.com/213005933903348"
        target="_blank"
        rel="noopener noreferrer"
      >
        Flux en cas de sinistre Safebike (Materné)
      </a>
    </li>
  );

  return (
    <Row type="flex" justify="center">
      <Col span={12}>
        <Card
          style={{
            padding: 20,
            background: "#fff",
            boxShadow: "0 5px 5px rgba(0,0,0,0.25)",
          }}
        >
          {userDetails.language === "fr" ? (
            <>
              <h1>Informations sur les assurances</h1>
              <p>
                Si vous avez un dossier de sinistre ou de vol, vérifiez auprès
                de la société de leasing et de l'assurance de l'entreprise. Tous
                les vélos sont couverts par une assurance omnium, sauf dans les
                dossiers où l'assurance est facultative. Cela peut être le cas
                chez les sociétés de leasing Ayvens ou B2Bike (achat ou
                leasing).
              </p>
              <p>
                Si vous ne connaissez pas la société de leasing, vous pouvez la
                trouver dans{" "}
                <a
                  href="https://docs.google.com/spreadsheets/d/1iYY5hI8O0FCbe8H3akhxXG1qrvtl8eLXIioNos8EVxc/edit?usp=sharing"
                  target="_blank"
                >
                  cet aperçu des entreprises.
                </a>
              </p>
              <p>
                Vérifiez s'il existe une assurance en suivant les étapes
                suivantes :
              </p>
              <ul>
                <li>Vérifiez la colonne « société de leasing »</li>
                <li>
                  Vérifiez la colonne « assurance » : assurance obligatoire ou
                  facultative ? Quelle assurance ?
                </li>
                <li>
                  Si elle est facultative : vérifiez si le client a souscrit
                  l'assurance
                </li>
                <li>Dans l'application Dealapp : « mes devis »</li>
                <ol>
                  <li>Recherchez le client par son nom de famille</li>
                  <li>Vérifiez l'offre du vélo livré</li>
                  <li>
                    Si le montant de l'assurance n'est pas « 0 », cela signifie
                    qu'il y a une assurance
                  </li>
                </ol>
              </ul>
              <p>
                En cas de doute ou de questions sur les assurances,
                contactez-nous au : 03/295 92 58 ou schade@b2bike.be
              </p>
              <br />
              <h2>Résumé dommage</h2>

              <Table
                columns={columnsFR}
                dataSource={dataSourceFR}
                pagination={false}
                bordered
              />

              <Text strong type="danger">
                * Exception : BASF / Eurochem passe par Materné
                (claims@materneverzekert.be)
              </Text>

              <Divider />

              <div class="fusion-layout-column fusion_builder_column fusion-builder-column-6 fusion_builder_column_2_3 2_3 fusion-two-third">
                <div class="fusion-column-wrapper fusion-flex-column-wrapper-legacy">
                  <div class="fusion-sep-clear"></div>
                  <div class="fusion-separator fusion-full-width-sep"></div>
                  <div class="fusion-sep-clear"></div>
                  <div class="fusion-text fusion-text-2">
                    <h2
                      data-fontsize="28"
                      data-lineheight="33.88px"
                      class="fusion-responsive-typography-calculated"
                    >
                      <h4>Par société de leasing</h4>
                    </h2>
                    <p>
                      <b>Alphabet</b>
                    </p>
                    <ul>
                      <li>
                        <a
                          href="https://docs.google.com/document/d/1rnOS7ICFNb3hP0V-HMMzhSI_20J7jypxeVtb4uWpXvI/edit?usp=sharing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Flux en cas de sinistre Alphabet
                        </a>
                      </li>
                    </ul>
                    <p>
                      <b>Ayvens</b>
                    </p>
                    <ul>
                      <li>
                        Assurance via Safebike (B2Bike)
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/file/d/1P9z9lwiP0-rgEAVl1pSlHXeJ5NXmnaTT/view?usp=sharing"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Flux en cas de sinistre Safebike
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        Assurance via Ayvens
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1-3eO0eKt1yGuoYiskTICZgvEuQJ37_8x"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Flux en cas de sinistre Ayvens
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1lFvNjhEsaT8dkykXrDbCueIuiyWjBYOv"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Formulaire dossier de sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        Garantie e-bike
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1UyS-s8T_lGwuSykzy5S-2jwpYf_695B6"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Déclaration sinistre
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1IE5T2CB-MtdPHM75r1Ycf6CKeOmCrIYf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Modèle de mail déclaration sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <p>
                      <b>Arval</b>
                    </p>
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/file/d/1fsdPXRP0oL6xbXU0iq74TM0TqM-wy75a/view?usp=sharing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Flux en cas de sinistre Arval
                        </a>
                      </li>
                      <li>
                        Garantie e-bike
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1UyS-s8T_lGwuSykzy5S-2jwpYf_695B6"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Déclaration sinistre
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1IE5T2CB-MtdPHM75r1Ycf6CKeOmCrIYf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Modèle de mail déclaration sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <p>
                      <b>B2Bike (aankoop of eigen lease)</b>
                    </p>
                    <ul>
                      {reportFormTheftDamageFR}
                      {reportFormTheftDamageMaternéFR}
                      <li>
                        Garantie e-bike
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1UyS-s8T_lGwuSykzy5S-2jwpYf_695B6"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Déclaration sinistre
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1IE5T2CB-MtdPHM75r1Ycf6CKeOmCrIYf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Modèle de mail déclaration sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeFs89Bvu9hyBOQjxuRQZgxcIb-m9CnOIVvAhyY2CLGfQ3XHg/viewform"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Info vélo de remplacement
                        </a>
                      </li>
                    </ul>
                    <p>
                      <b>Directlease</b>
                    </p>
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/file/d/1P9z9lwiP0-rgEAVl1pSlHXeJ5NXmnaTT/view?usp=sharing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Flux en cas de sinistre Safebike
                        </a>
                      </li>
                      <li>
                        Garantie e-bike
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1UyS-s8T_lGwuSykzy5S-2jwpYf_695B6"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Déclaration sinistre
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1IE5T2CB-MtdPHM75r1Ycf6CKeOmCrIYf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Modèle de mail déclaration sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeFs89Bvu9hyBOQjxuRQZgxcIb-m9CnOIVvAhyY2CLGfQ3XHg/viewform"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Info vélo de remplacement
                        </a>
                      </li>
                    </ul>
                    <p>
                      <b>J&amp;T</b>
                    </p>
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/file/d/1P9z9lwiP0-rgEAVl1pSlHXeJ5NXmnaTT/view?usp=sharing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Flux en cas de sinistre Safebike
                        </a>
                      </li>
                      <li>
                        Garantie e-bike
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1UyS-s8T_lGwuSykzy5S-2jwpYf_695B6"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Déclaration sinistre
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1IE5T2CB-MtdPHM75r1Ycf6CKeOmCrIYf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Modèle de mail déclaration sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeFs89Bvu9hyBOQjxuRQZgxcIb-m9CnOIVvAhyY2CLGfQ3XHg/viewform"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Info vélo de remplacement
                        </a>
                      </li>
                    </ul>
                    <p>
                      <b>VDFIN</b>
                    </p>
                    <ul>
                      <li>
                        <a
                          href="https://docs.google.com/document/d/14Cnq1ONKISYm_Y2U12Ra8dJU7sceuwaj_qZEqX7gyyI/edit?usp=sharing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Flux en cas de sinistre VDFIN
                        </a>
                      </li>
                      <li>
                        Garantie e-bike
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1UyS-s8T_lGwuSykzy5S-2jwpYf_695B6"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Déclaration sinistre
                            </a>
                            <ul>
                              <li>
                                <a
                                  href="https://drive.google.com/open?id=1IE5T2CB-MtdPHM75r1Ycf6CKeOmCrIYf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Modèle de mail déclaration sinistre
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <h3
                      data-fontsize="18"
                      data-lineheight="30.06px"
                      class="fusion-responsive-typography-calculated"
                    ></h3>
                    <h3
                      data-fontsize="18"
                      data-lineheight="30.06px"
                      class="fusion-responsive-typography-calculated"
                    ></h3>
                  </div>
                  <div class="fusion-clearfix"></div>
                </div>
              </div>
            </>
          ) : (
            <>
              <h1>Info verzekeringen</h1>
              <p>
                Heb je een schade of diefstal dossier, check de
                leasemaatschappij en verzekering van het bedrijf. Alle fietsen
                hebben een omniumverzekering, behalve in de dossiers waar de
                verzekering optioneel is. Dit kan voorvallen bij
                leasemaatschappij Ayvens of B2Bike (aankoop of leasing).
              </p>

              <p>
                Weet je de leasemaatschappij niet dan kun je dit vinden in{" "}
                <a
                  href="https://docs.google.com/spreadsheets/d/1iYY5hI8O0FCbe8H3akhxXG1qrvtl8eLXIioNos8EVxc/edit?usp=sharing"
                  target="_blank"
                >
                  dit overzicht van de bedrijven.
                </a>
              </p>
              <p>Kijk met volgende stappen na of er een verzekering is:</p>
              <ul>
                <li> Check kolom leasemaatschappij</li>
                <li>
                  {" "}
                  Check kolom verzekering: verzekering verplicht of optioneel?
                  Welke verzekering?
                </li>
                <li>
                  Indien optioneel: check of de klant de verzekering heeft
                  genomen
                </li>
                <li>In de Dealapp: ‘mijn offertes’</li>
                <ol>
                  <li>Zoek klant op familienaam</li>
                  <li>Check de offerte van de geleverde fiets</li>
                  <li>
                    Indien bij verzekeringsbedrag niet ‘0’ staat, dan is er een
                    verzekering
                  </li>
                </ol>
              </ul>
              <p>
                Bij twijfel of vragen over verzekeringen contacteer ons op:
                03/295 92 58 of schade@b2bike.be
              </p>
              <br />
              <h2>Schadeflow overview</h2>

              <Table
                columns={columnsNL}
                dataSource={dataSourceNL}
                pagination={false}
                bordered
              />

              <Text strong type="danger">
                * Uitzondering: BASF / Eurochem loopt via Materné
                (claims@materneverzekert.be)
              </Text>

              <Divider />
              <div class="fusion-text fusion-text-3">
                <h2>
                  <span>Per leasemaatschappij</span>
                </h2>
                <p>
                  <b>Alphabet</b>
                </p>
                <ul>
                  <li>
                    <a
                      href="https://docs.google.com/document/d/1wkICEDVBTUDwBcJBTJliGm85swPwtaz6dDrkX5e29Wc/edit?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Schadeflow Alphabet
                    </a>
                  </li>
                </ul>
                <p>
                  <b>Ayvens</b>
                </p>
                <ul>
                  <li>
                    <span>Verzekering via Safebike (B2Bike)</span>
                    <ul>{reportFormTheftDamageNL}</ul>
                  </li>
                  <li>
                    <span>Verzekering via Ayvens</span>
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1bE09Nyqm-S6wCVo0-UoYJqrGRmsxwyYj"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Schadeflow Ayvens
                        </a>
                        <ul>
                          <li>
                            Aangifte fiets{" "}
                            <a
                              href="https://drive.google.com/open?id=1X2TlLPHuoRLmfdTcfaSW_rE6K5QFdsqL"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              schadeformulier
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    E-bike garantie
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1UipaBOWh1pFN19CM2TWI98365bpFTdgy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Reparatiemelding flow
                        </a>
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1JYjLHp1uIYBHrOejc-bFKIrboRleiH3Z"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Mail template schademelding
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  <b>Arval</b>
                </p>
                <ul>
                  <li>
                    <a
                      href="https://drive.google.com/file/d/1628jWqO2kAqlB1M1eOTZHlAYfy_xCPyJ/view?usp=sharing"
                      target="_blank"
                      rel="noopener"
                    >
                      Schadeflow Arval
                    </a>
                  </li>
                  <li>E-bike garantie</li>
                  <li>
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1UipaBOWh1pFN19CM2TWI98365bpFTdgy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Reparatiemelding flow
                        </a>
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1JYjLHp1uIYBHrOejc-bFKIrboRleiH3Z"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Mail template schademelding
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  <b>B2Bike (aankoop of eigen lease)</b>
                </p>
                <ul>
                  {reportFormTheftDamageNL}
                  {reportFormTheftDamageMaternéNL}
                  <li>
                    <a
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdEIXQEQ0vX1A-M4gy_O7ys6pZCABcKA-TmLwrIrHyqT5vK0g/viewform"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>Info vervangfiets</span>
                    </a>
                  </li>
                  <li>
                    E-bike garantie
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1UipaBOWh1pFN19CM2TWI98365bpFTdgy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Reparatiemelding flow
                        </a>
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1JYjLHp1uIYBHrOejc-bFKIrboRleiH3Z"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Mail template schademelding
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  <b>Directlease</b>
                </p>
                <ul>
                  {reportFormTheftDamageNL}
                  <li>
                    <a
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdEIXQEQ0vX1A-M4gy_O7ys6pZCABcKA-TmLwrIrHyqT5vK0g/viewform"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>Info vervangfiets</span>
                    </a>
                  </li>
                  <li>
                    E-bike garantie
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1UipaBOWh1pFN19CM2TWI98365bpFTdgy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Reparatiemelding flow
                        </a>
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1JYjLHp1uIYBHrOejc-bFKIrboRleiH3Z"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Mail template schademelding
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  <b>J&amp;T</b>
                </p>
                <ul>
                  {reportFormTheftDamageNL}
                  <li>
                    <a
                      href="https://docs.google.com/forms/d/e/1FAIpQLSdEIXQEQ0vX1A-M4gy_O7ys6pZCABcKA-TmLwrIrHyqT5vK0g/viewform"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>Info vervangfiets</span>
                    </a>
                  </li>
                  <li>
                    E-bike garantie
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1UipaBOWh1pFN19CM2TWI98365bpFTdgy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Reparatiemelding flow
                        </a>
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1JYjLHp1uIYBHrOejc-bFKIrboRleiH3Z"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Mail template schademelding
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  <b>VDFIN</b>
                </p>
                <ul>
                  <li>
                    <a
                      href="https://docs.google.com/document/d/1iIalWuF0YSQrPBsQyW9fiBGs0xYM3Vamq7_8x6P1jUI/edit?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Schadeflow VDFIN
                    </a>
                  </li>
                  <li>
                    E-bike garantie
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/open?id=1UipaBOWh1pFN19CM2TWI98365bpFTdgy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Reparatiemelding flow
                        </a>
                        <ul>
                          <li>
                            <a
                              href="https://drive.google.com/open?id=1JYjLHp1uIYBHrOejc-bFKIrboRleiH3Z"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Mail template schademelding
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3></h3>
                <h4></h4>
                <h3></h3>
              </div>
            </>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default InfoDamage;
